import { ColumnFilter } from '../../../pages/ColumnFilter';
import "./Column.css"
export const COLUMNS = [
  {
    Header: "S.No.",
    accessor: "S. NO",
    sort: true,
    HeaderName:"SId",
    width:70,
    minwidth:40,
    maxwidth:150,
    Filter: ColumnFilter,
    Img:""
  },
  // {
  //   Header: "Course Code" ,
  //   accessor: "CourseCode",
  //   HeaderName:"CourseCode",
  //   Filter: ColumnFilter,
  //   width:180,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:<img
  //   src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
  //   width={60}
  //   alt='Filter-icon'
  //   className='Filter-icon'
  // />
  // },
  {
    Header: "Training Name",
    accessor: "Training Name",
    HeaderName:"Training Name",
    width:200,
    minwidth:40,
    maxwidth:150,
    Img:<img
    src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
    width={60}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  // {
  //   Header: "Session Code",
  //   accessor: "SessionCode",
  //   HeaderName:"SessionCode",
  //   Filter: ColumnFilter,
  //   width:180,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:<img
  //   src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
  //   width={60}
  //   alt='Filter-icon'
  //   className='Filter-icon'
  // />
  // },
  {
    Header: "Session Code",
    accessor: "Session Code",
    HeaderName:"Session Code",
    Filter: ColumnFilter,
    width:160,
    minwidth:40,
    maxwidth:150,
    Img:<img
    src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "Batch Size",
    accessor: "Batch Size",
    HeaderName:"Batch Size",
    Filter: ColumnFilter,
    width:100,
    minwidth:40,
    maxwidth:150,
    Img:<img
    src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "Start Date",
    accessor: "Start Date",
    HeaderName:"Start Date",
    Filter: ColumnFilter,
    width:80,
    minwidth:40,
    maxwidth:150,
    Img:<img
    src={process.env.PUBLIC_URL + "/images/LearningCalendar/nml-filter-icon.png"}
    alt='Filter-icon'
    className='Filter-icon'
  />
  },
  {
    Header: "End Date",
    accessor: "End Date",
    HeaderName:"End Date",
    Filter: ColumnFilter,
    width:80,
    minwidth:40,
    maxwidth:150,
    Img:""
  },
  // {
  //   Header: "Nomination Count",
  //   accessor: "NominationCount",
  //   HeaderName:"NominationCount",
  //   Filter: ColumnFilter,
  //   width:120,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:""
  // },
  // {
  //   Header: "Training Host",
  //   accessor: "Traininghost",
  //   HeaderName:"Traininghost",
  //   Filter: ColumnFilter,
  //   width:120,
  //   minwidth:40,
  //   maxwidth:150,
  //   Img:""
  // },
  {
    Header: "Practice",
    accessor: "Practice",
    HeaderName: "Practice",
    Filter: ColumnFilter,
    width:120,
    minwidth:40,
    maxwidth:150,
    Img:""
  },
  {
    Header: "Register",
    accessor: "Register",
    HeaderName:"Register",
    Cell: ({ row }) => (
        <a
          style={{ textDecoration: "none", color: "#7500c0" }}
          href={row.original.Register}
          target="_blank"
        >
          Click Here
        </a>
      ),
    Filter: ColumnFilter,
    width:120,
    minwidth:40,
    maxwidth:150,
  }
];